var map = {
	"./computer.gif": 98,
	"./dataloger.gif": 4002,
	"./dataloger1.gif": 8152,
	"./dataloger2.gif": 2934,
	"./fan.gif": 8089,
	"./thermosensor.gif": 7578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2650;